<template>
  <div class="container-fluid mt-5">
    <div>
      <card
        class="no-binvoice-card"
        body-classes="px-0 pb-1"
        footer-classes="pb-2"
      >
        <template slot="header">
          <div class="row">
            <div class="col-6">
              <h3 class="mb-0">
                {{ $t("RESELLER_INVOICES.RESELLER_INVOICES_LIST") }}
              </h3>
            </div>
            <div class="col-6 text-right">
              <base-button
                type="primary"
                icon
                size="sm"
                @click="addResellerInvoice()"
                v-if="
                  $currentUserCan($permissions.PERM_CREATE_RESELLER_INVOICES)
                "
              >
                <span class="btn-inner--icon">
                  <i class="fas fa-plus"></i>
                </span>
                <span class="btn-inner--text">
                  {{ $t("RESELLER_INVOICES.ADD_RESELLER_INVOICE") }}
                </span>
              </base-button>

              <notification-subscription
                v-if="$currentUserCan($permissions.PERM_VIEW_RESELLER_INVOICES)"
                :objectType="'reseller-invoices'"
                :events="{
                  CREATE: $t('NOTIFICATIONS.EVENT_CREATE'),
                  UPDATE: $t('NOTIFICATIONS.EVENT_UPDATE'),
                  DELETE: $t('NOTIFICATIONS.EVENT_DELETE'),
                }"
              />
            </div>
          </div>
        </template>

        <resellerInvoice-list-table />
      </card>
    </div>
  </div>
</template>
<script>
import { Button } from "element-ui";
import NotificationSubscription from "@/components/NotificationSubscription.vue";
import ResellerInvoiceListTable from "./partials/ResellerInvoiceListTable.vue";

export default {
  layout: "DashboardLayout",

  components: {
    ResellerInvoiceListTable,
    NotificationSubscription,
    [Button.name]: Button,
  },

  mixins: [],

  computed: {},

  watch: {},

  methods: {
    addResellerInvoice() {
      this.$router.push({ name: "Add ResellerInvoice" });
    },
  },
};
</script>
